"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 */
var DurationInterval = /** @class */ (function () {
    function DurationInterval() {
    }
    return DurationInterval;
}());
exports.DurationInterval = DurationInterval;
/**
 *
 */
var DurationIntervalLegacy = /** @class */ (function () {
    function DurationIntervalLegacy() {
    }
    return DurationIntervalLegacy;
}());
exports.DurationIntervalLegacy = DurationIntervalLegacy;
/**
 * An activity that may be performed by a participant in a study.
 */
var Activity = /** @class */ (function () {
    function Activity() {
    }
    return Activity;
}());
exports.Activity = Activity;
